import { useConfigContext } from '../contexts/ConfigContext/ConfigContext';

export function useComponentsConfig() {
  const {
    state: { componentsConfig },
    actions: { setComponentsConfig },
  } = useConfigContext();

  const getComponentConfigById = (componentId: string) => {
    return componentsConfig.find((e) => e.id === componentId);
  };

  return { getComponentConfigById, setComponentsConfig };
}
